import { Form } from "react-bootstrap";
import { z } from "zod/v4";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { useForm } from "../common/form/useForm";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { Button } from "../components/Button";
import { useBranding } from "../hooks/use-app-metadata";
import { AuthPage } from "../layout/AuthLayout";
import { useAuth } from "./useAuth";

const Schema = z.object({
	email: z.string().email("Please provide a valid email"),
});

export const PageVerifyResend = () => {
	const branding = useBranding();
	const { resendVerification } = useAuth();
	const form = useForm({
		validationSchema: toFormikValidationSchema(Schema),
		initialValues: {
			email: "",
		},
		onSubmit: (values) => {
			return resendVerification.mutateAsync(values.email);
		},
	});

	return (
		<AuthPage title="Resend email verification">
			<Form className="auth-form" onSubmit={form.handleSubmit}>
				<h1 className="mb-4">Resend verification email</h1>
				<p>Enter your unverified email address</p>

				<ExtraForm.Group label="Email">
					<ExtraForm.Control
						placeholder="email"
						type="email"
						data-testid="resend-verification"
						{...form.getFieldProps("email")}
						{...form.getFieldState("email")}
					/>
				</ExtraForm.Group>

				<Button full className="my-3" loading={form.isSubmitting} type="submit">
					Resend Verification
				</Button>
				<footer>
					{branding.footerText ??
						`© ${new Date().getFullYear()} ${branding.appName}. All rights reserved`}
				</footer>
			</Form>
		</AuthPage>
	);
};
